import { Component, inject, Input } from '@angular/core';
import { AssetService } from '../../../../../services/asset.service';
import { ModalableYedo } from '../../../../../models/modalable-yedo';
import { QuickLinkSignFormData } from '../../../../../models/quick-link-sign-form-data';
import { ResponseStatus } from '../../../../../models/modalable';
import { ModalComponent } from '../../../../../models/modal-component';
import { SignFormComponent } from '../../../page/book-feature/page-quick-link/sign-form/sign-form.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-yedo-modal',
    templateUrl: './yedo-modal.component.html',
    styleUrls: ['./yedo-modal.component.scss'],
    standalone: true,
    imports: [
        SignFormComponent,
        NgClass
    ]
})
export class YedoModalComponent extends ModalComponent {
    @Input() declare modalable: ModalableYedo;
    protected eResponseStatus = ResponseStatus;
    protected assetService = inject(AssetService);

    formData: QuickLinkSignFormData;

    close(): void {
        $('html')
            .css('cursor', 'initial');
    }

    getId(): string {
        return this.modalable.getModalId();
    }
}
